<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="success" @click="getCartAddress"
        ><v-icon>done</v-icon><span>Confirm Order</span></v-btn
      >
    </template>

    <v-card>
      <v-card-title>
        <h2>Confirm Order</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field
            v-model="cartId"
            label="CartId"
            prepend-icon="shopping_cart"
            disabled
          ></v-text-field>
          <v-textarea
            v-model="address"
            label="Address"
            prepend-icon="edit"
            :rules="inputRules"
          ></v-textarea>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirmOrder"
            class="success mx-1 mt-3"
            :loading="loadingConfirm"
            ><v-icon>done</v-icon><span> Confirm order</span></v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String,
    },
  },
  data() {
    return {
      address: "",
      inputRules: [
        (v) => !!v || "This field is required",
        (v) => v.length >= 3 || "Minimum length is 3 characters",
      ],
      loadingConfirm: false,
      loadingCancel: false,
      dialog: false,
    };
  },
  methods: {
    async getCartAddress() {
      let tmpAddress = await cartApi.getPaymentForCart(this.cartId);
      this.address = this.prepareAddress(tmpAddress.customerAddress);
    },
    async copyAddress() {
      let copyRes = false;
      await navigator.clipboard.writeText(this.cartAddress).then(function() {
        copyRes = true;
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
      if (copyRes) this.$toast("Copied address");
      this.dialog = false;
    },
    prepareAddress(address) {
      let updatedAddress = address.replace(/<br>/g, "\n");
      updatedAddress = updatedAddress + "\n\n";
      return updatedAddress;
    },
    confirmOrder() {
      if (this.$refs.form.validate()) {
        this.loadingConfirm = true;
        cartApi.confirmOrder(this.cartId, this.address).then(() => {
          this.loadingConfirm = false;
          this.dialog = false;
          this.$emit("orderChanged");
        });
      }
    },
  },
};
</script>
